<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="center-name">Enter New Center Name</div>
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <v-text-field label="Center Name" v-model="centerName" dense outlined hide-details class="required"></v-text-field>
                    <InputError :data='error.center' />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="right-align">
                        <v-btn :loading="loading" @click="onDone" class="right-btn cust-btn" color="primary">Done</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'Addcenter',
    props: ['onClose','status'],
    data() {
        return {
            centerName: "",
            loading:false,
            error: {
                center: {
                    type: null,
                    message: null,
                }
            },
        }
    },
    methods: {
        ...mapActions({
            upsertCenter: "centerAndBatchStore/upsertCenter",
        }),
        onDone()
        {
              if(this.validate())
              {
                let reqData={
                  name:this.centerName
                }
                this.loading = true;
                this.upsertCenter(reqData).then(response => {
                        this.loading = false;
                        this.onClose({status:false,reload:true})
                        this.$toasted.success(`${response.msg}`, { icon: 'check_circle' });
                    })
                    .catch(err => {
                        this.loading = false;
                    });
              }  
        },
        validate() {
            let isValid = true;
            this.error.center.type = null;
           
           
            if(!this.centerName||this.centerName.trim().length<1)
            {            
                this.error.center.type = 'error';
                this.error.center.message = 'Please enter center name';
                isValid = false;
            } else if(this.centerName && this.centerName.trim().length>100){
                this.error.center.type = 'error';
                this.error.center.message = 'Name should not contain more than 100 characters';
                isValid = false;
            }
                    
            return isValid;
        },
    },
    watch:{
      centerName(val)
      {
        if(val.trim().length)
        {
            this.error.center.type=null;
        }
      },
      status(val)
      {
        this.error.center.type=null;
          if(!val)
          {
          this.centerName="";
          }
      }
    }
}
</script>